var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { theme } from '../theme';
export var BackgroundContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &:not([data-simulated='true']) {\n    background-color: ", ";\n  }\n"], ["\n  &:not([data-simulated='true']) {\n    background-color: ", ";\n  }\n"])), theme.color('background'));
var templateObject_1;
//# sourceMappingURL=Background.style.js.map